export const GET_TRANSLATIONS_REQUEST = "GET_TRANSLATIONS_REQUEST"
export const GET_TRANSLATIONS_SUCCESS = "GET_TRANSLATIONS_SUCCESS"
export const CHANGE_LNAGUAGE = "CHANGE_LNAGUAGE"